import Vue from 'vue';
import { pusher, keycloakService } from '@/plugins';
import App from './App';
import router from './router';
import store from './store';
import LocalizedLabel from './components/LocalizedLabel';
import i18n from './i18n';
import vuetify from './plugins/vuetify';

Vue.use(LocalizedLabel);
Vue.config.productionTip = false;

(async () => {
  const translations = (await i18n.backoffice()).default;
  const isAuthenticated = await keycloakService.init();

  if (isAuthenticated) {
    store.state.translations = translations;

    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');

    // Initialize Pusher with the authenticated user's ID.
    pusher.init(keycloakService.userData.id, store);
  } else {
    window.location.reload();
  }
})();
